var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-rfq',{ref:"Form",attrs:{"data":_vm.data,"dataID":_vm.data.id,"model":_vm.getModel},on:{"updateModelItem":_vm.handlerUpdateModelItem,"change":function($event){return _vm.$emit('change', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }